require('masonry-layout/dist/masonry.pkgd');
require('imagesloaded/imagesloaded.pkgd');
jQuery(document).ready(function($){
    let $grid = $('.news-container').masonry({
        gutter: 40
    });
    $grid.imagesLoaded().progress(function(){
        $grid.masonry('layout');
    })
});